import { Pipe, PipeTransform } from '@angular/core';
import { Indicator } from 'src/business/services/client.generated';

@Pipe({
    name: 'indicatorSort',
    standalone: true
})
export class IndicatorSortPipe implements PipeTransform {

    transform(value: Indicator[]): Indicator[] {
        return value.sort((x, y) => (x.display == "Top" ? 0 : 1) - (y.display == "Top" ? 0 : 1));
    }

}
